import React, { useState, useRef, useEffect } from 'react'

export default function MaterialDropdown({ materials, value, onChange, onAddNew }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const selected = materials.find(m => m.id === value)
  useEffect(() => {
    function handler(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])
  const grouped = {}
  for (const m of materials) {
    if (!grouped[m.category]) grouped[m.category] = []
    grouped[m.category].push(m)
  }
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button style={dd.trigger} onClick={() => setOpen(!open)} type="button">
        <span style={{ flex: 1, textAlign: 'left', fontSize: '12px', color: selected ? '#374151' : '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {selected ? `${selected.name} ($${selected.unit_cost}/${selected.unit})` : '— pick material —'}
        </span>
        <span style={{ fontSize: '10px', color: '#9ca3af' }}>▾</span>
      </button>
      {open && (
        <div style={dd.menu}>
          <button style={dd.clearOption} onClick={() => { onChange(null); setOpen(false) }}>— none —</button>
          {Object.entries(grouped).map(([cat, mats]) => (
            <div key={cat}>
              <div style={dd.catHeader}>{cat}</div>
              {mats.map(m => (
                <button key={m.id} style={{ ...dd.option, background: value === m.id ? '#f0fdf4' : 'white', color: value === m.id ? '#15803d' : '#374151' }} onClick={() => { onChange(m.id); setOpen(false) }}>
                  <span style={{ flex: 1 }}>{m.name}</span>
                  <span style={{ fontSize: '11px', color: '#9ca3af' }}>${m.unit_cost}/{m.unit}</span>
                </button>
              ))}
            </div>
          ))}
          <div style={dd.addRow}><button style={dd.addBtn} onClick={() => { setOpen(false); onAddNew() }}>+ Add New Material</button></div>
        </div>
      )}
    </div>
  )
}

const dd = {
  trigger: { width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #e5e7eb', background: '#fafafa', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'inherit' },
  menu: { position: 'absolute', top: 'calc(100% + 2px)', left: 0, right: 0, background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: '280px', overflowY: 'auto' },
  catHeader: { padding: '6px 12px 3px', fontSize: '10px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.6px', background: '#f9fafb', borderTop: '1px solid #f3f4f6' },
  option: { width: '100%', padding: '8px 12px', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontFamily: 'inherit', fontSize: '13px', textAlign: 'left', borderBottom: '1px solid #f9fafb' },
  clearOption: { width: '100%', padding: '8px 12px', border: 'none', background: 'white', cursor: 'pointer', fontSize: '12px', color: '#9ca3af', fontFamily: 'inherit', textAlign: 'left', borderBottom: '1px solid #f3f4f6' },
  addRow: { padding: '8px 12px', borderTop: '1px solid #e5e7eb', background: '#f9fafb' },
  addBtn: { width: '100%', padding: '7px 12px', background: '#2d6a2d', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' },
}
